// test1960
(1960 && 0);
